import api, { setToken } from '@/common/api.js'
import router from '@/router'

export default {
  namespaced: true,

  state: {
    filial: null,
    filiaisTemp: null,
    filialPainel: null,
    allFiliais: null,
    fornecedores: null,
    infColab: null
  },

  getters: {
    filial: (state) => {
      if (state.filial && state.filial.token && state.filial) {
        return state.filial
      }

      return null
    },
    filialPainel: (state) => {
      if (state.filialPainel) {
        return state.filialPainel
      }

      return null
    },
    token: (state) => {
      if (state.filial && state.filial.token) {
        return state.filial.token
      }

      return null
    },
    fornecedores: (state) => {
      return state.fornecedores
    },
    allFiliais: (state) => {
      return state.allFiliais
    },
  },

  actions: {
    actionSidebar(){
      const sidebar = document.getElementById('sidebar')
      const iconSidebar = document.getElementById('spanIconSidebar')
      const content = document.getElementById('layout-top-nav')
      const divColaborador = document.getElementById('divColaborador')
      const widthSidebar = document.getElementById('sidebar').offsetWidth

      const isMobile = window.screen.width;

      if (isMobile <= 991) {
        if (widthSidebar == '0') {
          sidebar.style.width = '300px'
          iconSidebar.textContent = 'X',
            divColaborador.style.display = 'block'
        } else {
          sidebar.style.width = '0px'
          iconSidebar.textContent = '☰'
          divColaborador.style.display = 'none'
        }
      } else {
        if (widthSidebar == '95') {
          console.log('95px')
          sidebar.style.width = '300px'
          content.style.marginLeft = '300px'
          iconSidebar.textContent = 'X'
          divColaborador.style.display = 'block'
        } else {
          console.log('ELSE')

          sidebar.style.width = '95px'
          content.style.marginLeft = '95px'
          iconSidebar.textContent = '☰'
          divColaborador.style.display = 'none'
        }
      }
    },
    async getAllFiliais({ commit }, { nrSeqClifor }) {
      try {
        const response = await api.get(`os/filial/${nrSeqClifor}`)

        commit('setAllFiliais', response.data)
      } catch (error) {
        commit('setAllFiliais', [])
        throw Error(error)
      }
    },
    async getLocation({ commit }) {
      try {
        const response = await api.get(`os/getLocation`)

        return response.data

      } catch (error) {

        throw Error(error)
      }
    },
    async getFornecedores({ commit, state }) {
      try {
        const response = await api.get('os/getFornecedores')

        commit('setFornecedores', response.data)
      } catch (error) {
        throw Error(error)
      }
    },
    loadFromLocalStorage: ({ commit, state }) => {
      if (localStorage.filial) {
        const filial = JSON.parse(localStorage.filial)

        if (filial.token && filial.ds_filial) {
          commit('setFilial', filial)
        }
      }
    },
    loadFromLocalStoragePainel: ({ commit, state }) => {
      if (localStorage.filialPainel) {
        const filial = JSON.parse(localStorage.filialPainel)

        commit('setFilialPainel', filial)
      }
    },

    async login({ commit, state }, { data }) {
      try {
        const response = await api.post('auth/login', data)

        const filial = {
          ...response.data.filial,
          token: response.data.token,
          atendeOs: response.data.atendeOs[0].st_atendeos,
          tecnicoId: response.data.tecnicoId,
          dsColaborador: response.data.dsColaborador,
          fornecExt: response.data.fornecExt,
          allFiliais: response.data.allFiliais,
          allFiliaisTemp: response.data.allFiliais,
          allEmpresas: response.data.empresas,
          perfilMecanico: response.data.perfilMecanico,
          st_inventario: response.data.st_inventario,
          infColab: data,
          foto: response.data.foto,
          ambiente: data.ambiente_temp,
          tipoPerfilTerminal: response.data.tipoPerfilTerminal,
          location: response.data.location,
          exibe_os_encerrada: response.data.exibe_os_encerrada
        }

        commit('setFilial', filial)
        return response
      } catch (error) {
        commit('unsetFilial')
        throw new Error(error)
      }
    },

    async setLocalStorageFilial({ commit }, { data }) {
      // 1. Recuperar o JSON do localStorage
      var jsonFromLocalStorage = localStorage.getItem('filial');

      // 2. Converter o JSON em um objeto JavaScript
      var objetoJSON = JSON.parse(jsonFromLocalStorage);

      // 3. Alterar o valor da chave "ambiente" para 'P'
      objetoJSON.ambiente = data.toString();

      // 4. Converter o objeto de volta para JSON
      var novoJSON = JSON.stringify(objetoJSON);

      // 5. Atualizar o valor no localStorage
      localStorage.setItem('filial', novoJSON);
    },

    async loginPainel({ commit, state }, { data }) {
      try {
        const response = await api.post('painel/loginPainel', data)

        commit('setFilialPainel', response.data.colabPainel)
      } catch (error) {
        commit('unsetFilialPainel')
        throw new Error(error)
      }
    },

    async logout({ commit, state }) {
      try {
        commit('unsetFilial')
      } catch (error) {
        throw new Error(error)
      }
    }
  },

  mutations: {
    setFornecedores(state, fornecedores) {
      state.fornecedores = fornecedores
    },
    setAllFiliais(state, fornecedores) {
      state.fornecedores = fornecedores
    },
    setFilial(state, filial) {
      localStorage.filial = JSON.stringify(filial)
      setToken(api)
      state.filial = filial
    },
    setFilialPainel(state, filial) {
      localStorage.filialPainel = JSON.stringify(filial)
      state.filialPainel = filial
    },

    unsetFilial(state) {
      localStorage.removeItem('filial')
      state.filial = null
      router.push('/login')
    },

    unsetFilialPainel(state) {
      localStorage.removeItem('filialPainel')
      state.filialPainel = null
      router.push('/loginPainel')
    }
  }
}
